<template>
    <div class="form-group row" ref="formRow">
      <label :class="['col-form-label', labelColumnClass]" v-if="labelColumnSize > 0">{{label}}
        <slot name="label"></slot>
        <br v-if="helpTip" />
        <a v-show="helpTip" rel="tooltip" @click.prevent="" data-toggle="tooltip" data-placement="right" :title="helpTip"><i class="far fa-info-circle" style="color: #979a9c;"></i></a>
      </label>
      <div :class="[fieldColumnClass]" v-if="fieldCount == 1">
        <slot />
      </div>

      <template v-if="fieldCount > 1">
        <div :class="[fieldColumnClass]" v-for="fieldNumber in fieldList" :key="fieldNumber">
          <slot :name="`field${fieldNumber}`" />
        </div>
      </template>

      <div v-if="suffix" class="col-sm-2 col-form-label" style="padding-left: 0px;">{{suffix}}</div>
      <div v-if="suffixSlot" class="col-sm-2" style="padding-left: 0px;">
        <slot name="suffix"></slot>
      </div>
    </div>
</template>

<script>
import formField from '@/mixins/formField'
export default {
  name: "FormRow",
  props: {
    label: String,
    suffix: {
      type: String,
      default: ''
    },
    suffixSlot: {
      type: Boolean,
      default: false
    },
    helpTip: {
      type: String,
      default: ''
    },
    labelColumnSize: {
      type: Number,
      default: 2
    },
    fieldCount: {
      type: Number,
      default: 1
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  computed: {
    labelColumnClass() {
      let defaultLabelColumnSize = 2

      var size = parseInt(this.$props.labelColumnSize)
      if(this.$parent.labelColumnSize != undefined && size == defaultLabelColumnSize)
        size = parseInt(this.$parent.labelColumnSize)

      return `col-sm-${size}`
    },
    fieldColumnClass() {
      let defaultLabelColumnSize = 2

      var size = 12 - parseInt(this.$props.labelColumnSize)
      if(this.$parent.labelColumnSize != undefined && parseInt(this.$props.labelColumnSize) == defaultLabelColumnSize)
        size = 12 - parseInt(this.$parent.labelColumnSize)
      if(this.$props.fieldCount > 1)
        size = Math.floor(size / this.$props.fieldCount)

      if(this.suffix != '' || this.suffixSlot)
        size -= 2

      return `col-sm-${size}`
    },
    fieldList() {
      return Array.from({length: this.$props.fieldCount}, (v, k) => k+1)
    }
  }
};
</script>